import { LitElement, html } from "lit-element";
import { connect } from "pwa-helpers/connect-mixin.js";
import { store } from "../inspx-store.js";
import {
	updateCurrentInspection,
	savePhotos,
	deletePhotoById,
	deleteDrawingById,
	loadRemoteInspSuccess,
	updateCurrentRemoteInspection
} from "../actions/inspection.js";
import { SharedStyles } from "../styles/shared-styles.js";
import { CardStyles } from "../styles/card-styles.js";
import { add, del, contentCopy } from "../styles/icons.js";
import "../elements/inspx-ajax-image.js";
import "../elements/inspx-inspection-card.js";
import "../elements/inspx-db-images-container.js";
import { validateSchemaPart } from "../lib/inspxValidationModule.js";
import { computeParts, groupBy } from "../lib/helpers.js";
import { validateCurrentInspectionTab } from "../actions/validation.js";
import clientPull from "../lib/clientPull.js";

class RemoteInspection extends connect(store)(LitElement) {
	shouldUpdate(changedProps) {
		const r =
            (this.data && this.schema) ||
            (changedProps && changedProps.tab != this.tab) ||
            this.pageType === "images" ||
            this.pageType === "drawings";

		return r;
	}

	async updated(changedProps) {
		if (this.pageType === "array" && changedProps.has("data") && changedProps.get("data") != undefined && !changedProps.has('tab') && this.data.length > changedProps.get("data").length) {

			let list = this.shadowRoot.querySelector(".list");

			await this.updateComplete;
			let cld = list.children[list.children.length - 2];
			let upd = await cld.updateComplete;
			if (upd && cld.parts && cld.parts.length > 0) {

				//cld.scrollIntoView()
			}
		}

	}

	render() {
		return (this.__reset)
			? html``
			: html`
            ${SharedStyles}
            ${CardStyles}
            <style>
                :host {
                    height: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: flex-start;
                    padding : 10px;
                }
            
                .list {
                    display: grid;
                    grid-gap: 20px;
                    grid-auto-flow: dense;
                    grid-template-columns: repeat(auto-fill, minmax(420px, max-content));
                    margin: 10px;
                    box-sizing: border-box;
                    flex-grow: 1;
                }

                .no-items-msg {
                    text-align: center;
                    width: 100%;
                }

                .flex .card {
                  width: auto;
                }

                .large-images {
                    --db-image-height: 300px;
                }

                .fab {
                    cursor: pointer;
                    position: absolute;
                    right: 40px;
                    background-color: var(--secondary-color);
                    bottom: 20px;
                    border-radius: 50%;
                    width: 42px;
                    height: 42px;
                    align-items: center;
                    display: flex;
                    justify-content: space-around;
                    fill: white;
                }

                .tall{
                    width: auto;
                    margin: 10px;
                }
				
				.array-card-buttons {
                    cursor: pointer;
                    padding: 0;
                    display: flex;
                    fill: var(--secondary-color);
                }

				.array-card-buttons > * {
					margin-left: 25px;
				}

                @media only screen and (max-width: 460px) {
                    :host {
                        padding: 0;
                    }
                    
                    .list {
                        grid-template-columns: repeat(auto-fill, minmax(300px, 440px));
                    }
                }
            </style>
            
            ${this.renderFunctions[this.pageType]()}`;
	}

	renderImages() {

		const lastRenderd = new Date().getTime();
		return html`
			<inspx-db-images-container isRemote class="list large-images" hideAddPhoto all
				.lastRendered="${lastRenderd}"
				.inspectionid="${this.inspId}">
			</inspx-db-images-container>`;
	}

	renderDrawings() {
		//lastRendered makes lit-html rerender because other dependencies of inspx-db-images-container never change.
		const lastRenderd = new Date().getTime();
		return html`
			<inspx-db-images-container class="list large-images" hideAddPhoto all drawing
				.lastRendered="${lastRenderd}"
				.inspectionid="${this.inspId}">
			</inspx-db-images-container>`;
	}

	renderArray() {
		if (!this.data) return;

		if (this.data.length === 0) {
			return html`
                <p class="no-items-msg">No items added.</p>`;
		}

		return html`
			<div class="list">
				${this.data.map((a, i) => this.renderArrayItem(a, i))}
			</div>`;
	}

	renderArrayItem(a, i) {
		const pathPrefix = this.tab + '.' + i;


		return html`
			<inspx-inspection-card class="card"
				.inspId="${this.inspId}"
				.cardtitle="${this.schema.items.showIndex ? this.schema.items.title + " " + (i + 1) : this.schema.items.title}"
                .data="${a}"
                ?disabled="${!INSP.APP.openedFromCore}"
				.parts="${computeParts(this.schema.items)}"
				.pathprefix="${pathPrefix}"
				.invalidFields="${this.validation.invalidFields}">
			
			</inspx-inspection-card>`;
	}

	renderObject() {
		let parts = computeParts(this.schema);
		let gr = groupBy(parts, p => p.tall);
		let tall = gr.get(true) || [];
		let regular = gr.get(undefined) || [];

		let css = tall.length > 0 ? 'flex' : "";


		return html`
            ${tall.map(a => this.renderObjectItem(a, "tall"))}
			<div class="list ${css}">
				${regular.map(a => this.renderObjectItem(a))}
			</div>`;
	}

	renderObjectItem(a, cssClass = "") {
		const pathPrefix = this.tab + '.' + a.name;
		return html`
			<inspx-inspection-card class="card ${cssClass}"
				.inspId="${this.inspId}"
                .cardtitle="${a.title}"
                ?disabled="${!INSP.APP.openedFromCore}"
				.data="${this.data[a.name] || {}}"
                .pathprefix="${pathPrefix}" 
				.parts="${computeParts(a)}"
				.invalidFields="${this.validation.invalidFields}">
            </inspx-inspection-card>`;
	}

	static get properties() {
		return {
			data: Object,
			schema: Object,
			tab: String,
			validation: { type: Object },
		};
	}

	disconnectAllNestedComponents() {
		this.__reset = true;
		this.requestUpdate()
			.then(() => {
				this.__reset = false;
				this.requestUpdate();
			})
	}

	_checkInitialArrayItem() {
		const promise = (this.data.length === 1 && Object.getOwnPropertyNames(this.data[0]).length === 0)
			? store.dispatch(
				updateCurrentInspection({
					path: this.tab + ".0",
					value: {}
				}))
			: Promise.resolve();
		return promise;
	}

	addArrayItem() {
		const promise = this._checkInitialArrayItem();
		promise.then(() => {
			return store.dispatch(
				updateCurrentInspection({
					path: this.tab + "." + this.data.length,
					value: {},
					action: { name: "addArrayItem" }
				})
			);
		});
	}

	copyArrayItem(item) {
		const promise = this._checkInitialArrayItem();
		promise.then(() => {
			store.dispatch(
				updateCurrentInspection({
					path: this.tab + "." + this.data.length,
					value: item,
					action: { name: "arrayItemCopy" }
				})
			);
		});
	}

	deleteArrayItem(i, a) {
		if (a.connected_images) {
			Object.keys(a.connected_images).map(i => {
				store.dispatch(deletePhotoById(a.connected_images[i])).then(() => {
					e.detail.el.remove();
				});
			})
		}
		store.dispatch(
			updateCurrentInspection({
				path: this.tab,
				action: { name: "deleteArrayItem", index: i }
			})
		);
	}

	validateCard(eventDetail) {
		const target = eventDetail.target;
		const path = eventDetail.path;

		if (!target || !path) return;

		const pathParts = path.split('.');
		const p = { tab: pathParts[0], card: pathParts[1], field: pathParts[2] };
		const isPathValid = (p.tab && p.card && p.field && this.tab === p.tab);
		if (isPathValid) {
			const isArray = this.schema.type === 'array' && Number.isInteger(Number.parseFloat(p.card));

			const cardData = this.data[p.card] || {};
			const cardSchema = isArray ? this.schema.items : this.schema.properties[p.card];
			const valResult = validateSchemaPart(cardSchema, cardData, this.insp);

			let isInvalid = false;
			if (valResult.valid) {
				if (this.validation.invalidTabs.indexOf(p.tab) > -1) {
					store.dispatch(validateCurrentInspectionTab(this.tab));
				}
			} else {
				isInvalid =
                    valResult.errors.findIndex(e =>
                    	e.dataPath && path.endsWith(e.dataPath)) > -1 ||
                    valResult.errors.findIndex(e =>
                    	e.keyword === 'required' && e.params.missingProperty === p.field) > -1;
			}
			target.isInvalid = isInvalid;
		}
	}

	constructor() {
		super();
		this.items = [];

		this.addEventListener("inspx-input-blur", e => {
			this.validateCard(e.detail);
		});

		this.addEventListener("inspx-change", e => {
			store.dispatch(updateCurrentRemoteInspection(e.detail)).then(() => {
				this.validateCard(e.detail);
			});
		});

		this.addEventListener("photos-selected", e => {
			store.dispatch(savePhotos(e.detail)).then(() => {
				e.detail.container.requestUpdate();
			});
		});

		this.addEventListener("photo-delete", e => {
			store.dispatch(deletePhotoById(e.detail.id)).then(() => {
				e.detail.el.remove();
			});
		});

		this.addEventListener("drawing-delete", e => {
			store.dispatch(deleteDrawingById(e.detail.id)).then(() => {
				e.detail.el.remove();
			});
		});

		this.renderFunctions = {
			object: this.renderObject.bind(this),
			array: this.renderArray.bind(this),
			images: this.renderImages.bind(this),
			drawings: this.renderDrawings.bind(this)
		};
	}

	async stateChanged(state) {
		if (state.app.route.id)
			if (!this.inspId || this.inspId !== state.app.route.id) {
				let token = localStorage.getItem("token");
				this.inspId = state.app.route.id;
				let url = INSP.config.apiUrl;
				this.disconnectAllNestedComponents()

				let json = await clientPull(url, token, 'remoteInspection', { inspKey: this.inspId });

				store.dispatch(loadRemoteInspSuccess(json.data));

			}

		if (state.inspection.remote) {

			const insp = state.inspection.remote.inspection;
			const tab = state.app.route.subpage;
			this.inspId = state.app.route.id;

			if (tab != this.tab) {
				this.disconnectAllNestedComponents();
				this.tab = tab;
			}

			this.schema = insp.type.schema.properties[tab];
			this.pageType = tab == "images" || tab == "drawings"
				? tab
				: this.schema.type;

			if (insp && tab) {
				this.data = insp[tab] || (this.pageType === "array" ? [] : {});
			}

			this.validation = state.validation;
			this.insp = insp;
		}
	}
}

window.customElements.define("inspx-remote-inspection", RemoteInspection);
